module.exports = __webpack_public_path__ + "static/media/thumbnail.1e756067.jpg";